<style lang="scss" scoped>
  #searchBox {
    overflow: hidden;
  }
  .empty-info {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: column;
    align-content: center;
    margin-top: 50px;

    .txt {
      text-align: center;
      color: #C0C4CC;
      margin-top: 14px;
    }
  }

  .container {
    padding: 10px;
    .box {
      padding: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      margin-bottom: 15px;
      margin-left: -8.5px;
    }

    .sign {
      position: static;
      width: 5px;
      height: 16px;
      left: 0px;
      top: 3px;
      background: #419FFF;
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 10px;
    }

    .sign1 {
      position: static;
      width: 5px;
      height: 16px;
      margin-left: -3px;
      top: 3px;
      background: #419FFF;
      flex: none;
      order: 0;
      flex-grow: 0;
      margin: 0px 10px;
    }

    .text {
      font-size: 16px;
      font-family: Microsoft YaHei UI;
      line-height: 22px;
      color: #303133;
    }

    .info {
      display: flex;
      width: 400px;
      align-items: align-center;
      justify-content: space-around;
    }
  }

  .title {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 10px;
    font-size: 15px;
    font-weight: 500;
  }

  .checkbox {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .check:not(:first-child) {
      margin-left: 20px;
      font-size: 12px;
    }
  }

  .shortcut {
    text-align: left;

    .box {
      padding: 0;

      .txt {
        margin-left: 5px
      }

      li {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #fff;
        border: 1px solid #dcdfe6;
        color: #606266;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        padding: 7px 15px;
        font-size: 12px;
        border-radius: 3px;
        margin-left: 10px;
      }

      li.checked {
        // background-color: #b3d8ff;
        color: #409eff;
        border: 1px #b3d8ff solid;
      }
    }

  }

  .param {
    display: flex;
    justify-content: flex-start;
    margin-top: 10px;

    .txt {
      font-size: 13px;
      margin-left: 12px
    }

    .tag {
      margin-left: 8px;
    }
  }

  .form {
    text-align: left;
  }
</style>
<style>
  .diagram /deep/ .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll {
    margin-left: 10px;
  }
</style>
<template>
  <div class="container">
    <div>
      <el-row>
        <el-button type="text" style="margin-left:10px" @click="closeFilter">
          {{word}}
          <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
        </el-button>
      </el-row>
      <div v-show="showAll">
        <div class="box">
          <div class="sign"></div>
          <div class="text">{{$t('shujufanwei')}}</div>
        </div>
        <div>
          <el-form style="margin-left: 10px;" size="mini" :inline="true" :model="conditions" class="demo-form-inline">
            <el-form-item :label="$t('caijishijian')" required>
              <yi_time_input :maxTime="7 * 24 * 3600 * 1000" type="datetimerange" ref="yiTime"
                :start.sync="conditions.startTime" :end.sync="conditions.endTime" :key="key">
              </yi_time_input>
            </el-form-item>
            <el-form-item :label="$t('shebeimingcheng')" required="required">
<!--              <yi_cross_select multiple :component="'web_base_equipment_list'" :max="1"-->
<!--                :ids.sync="conditions.equipmentIds" :key="key">-->
<!--              </yi_cross_select>-->

              <yi_data_select :multiple="false" :type="'equipment'" :ids.sync="conditions.equipmentIds" :key="key">
              </yi_data_select>
            </el-form-item>
          </el-form>
        </div>
        <div>
          <div class="box">
            <div class="sign"></div>
            <div class="text">{{$t('gongyicanshu')}}</div>
          </div>
          <div>
            <shortcut :key="key" ref="shortcut" :sn="sn" :name="name" :equipmentId="equipmentId" :paramDict="paramDict"
              @selectTag="selectTag"></shortcut>
          </div>
          <el-row style="margin-left: 10px;margin-top: 15px;">
            <el-button :loading="loading" size="mini" type="primary" @click="getCraftAnalyze()">
              {{$t('shaixuan')}}</el-button>
            <el-button size="mini" @click="reset">{{$t('chongzhitiaojian')}}</el-button>
          </el-row>
        </div>
      </div>

      <div class="diagram" style="padding-left:10px;margin-top: 36px;">
       <div v-if="this.list.length>0" style="right: 10px;z-index: 1;position: absolute;margin-top: 10px;">
         <el-switch v-model="multiChart" :inactive-text="$t('duotumoshi')" />
       </div>
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('fenxitu')" name="first">
            <!-- 分析图 -->
            <div v-if="list.length > 0">
              <template v-if="multiChart">
                <multiple-chart :codes="pointCodes" :dict="paramDict" :list="list" :conditions="conditions"/>
              </template>
              <template v-else>
                <single-chart :codes="pointCodes" :dict="paramDict" :list="list" :key="reKey" :conditions="conditions"/>
              </template>
            </div>
            <div v-else class="empty-info">
              <div class="img">
                <img style="width: 84px;height:54px;margin-left: 24px;" src="../../../../assets/img/web/process_management/empty.svg" alt="empty" />
              </div>
              <div class="txt">
                {{$t('qingzaishaixuanlanxuanzeshujufanwei')}}
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('xiangqing')" name="second">
            <div v-if="tableColumn.length > 0">
              <el-table stripe max-height="600" :data="tableData.slice(
                (pagination.currentPage - 1) * pagination.pageSize,
                pagination.currentPage * pagination.pageSize)" border style="width: 100%"
                :header-cell-style="{background: '#F5F7FA',color:'#606266','font-weight':'700', height:'48px', padding:'0px'}">
                <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop"
                  :show-overflow-tooltip="true" :label="$t(item.label)">
                  <template slot-scope="scope">
                    <span v-if="item.prop === 'time'">
                      {{timestampToTime(scope.row[item.prop])}}
                    </span>
                    <span v-else>
                      {{scope.row[item.prop]}}
                    </span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="float: right; margin-top:8px">
                <el-pagination background size="mini" :pagerCount="5" :current-page="pagination.currentPage"
                  :page-size="pagination.pageSize" layout="total,prev, pager, next,sizes" :total="tableData.length"
                  @size-change="handleSizeChange" @current-change="handleCurrentChange" />

              </div>
            </div>
            <div v-else
              style="display: flex;justify-content: center;flex-wrap: wrap; flex-direction:column;align-content:center;margin-top: 50px;">
              <div>
                <img style="width: 84px;height:54px;margin-left: 24px;"
                  src="../../../../assets/img/web/process_management/empty.svg" />
              </div>
              <div style="text-align: center; color: #C0C4CC;margin-top: 14px;">
                {{$t('qingzaishaixuanlanxuanzeshujufanwei')}}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

    </div>
  </div>
</template>

<script>
  import shortcut from '@@/pages/web/process_management/analysis/shortcut'
  import multipleChart from "@@/pages/web/process_management/analysis/components/multiple_chart"
  import singleChart from "@@/pages/web/process_management/analysis/components/single_chart"
  import axios from 'axios';
  export default {
    name: 'web_process_management_analysis_index',
    components: {
      shortcut,
      multipleChart,
      singleChart
    },
    filters: {
      getCNNameByCode(code, that) {
        let res = that.paramDict.filter(item => {
          return item.code === code
        })
        if (res.length > 0) {
          const unit = res[0]['unit'];
          return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
        } else {
          return code
        }
      }
    },
    data() {
      return {
		loading: false,
        boolValue: true,
        pointCodes: [], // 已选工艺参数
        chartList: [], // 存储动态分析图
        showAll: false,
        activeName: 'first',
        conditions: {},
        key: 0,
		reKey: 0,
        sn: '',
        name: '',
        equipmentId: '',
        that: this,
        paramDict: [], // 工艺参数数据映射
        tableColumn: [], // 表格数据
        tableData: [], // 详情表格列
        totalPage: 0, // 统共页数
        pagination: {
          currentPage: 1,
          pageSize: 10
        },
        multiChart: true,
        list: [],
        axiosCancelSource: null
      }
    },
    computed: {
      word: function () {
        if (this.showAll === false) {
          return this.$t('zhankaishaixuantiaojian');
        } else {
          return this.$t('shouqishaixuantiaojian');
        }
      },

    },
    watch: {
      conditions: {
        handler(newVal) {
          if (newVal.equipmentIds) {
            this.equipmentId = newVal.equipmentIds
            let res = this.$store.state.eqs.filter(item => {
              return item.id === newVal.equipmentIds
            })
            this.sn = res.length > 0 ? res[0]['sn'] : ''
            this.name = res.length > 0 ? res[0]['name'] : ''
          }
          if (newVal.startTime && newVal.endTime) {
            let startDate = new Date(parseInt(newVal.startTime));
            let endDate = new Date(parseInt(newVal.endTime));
            let middle = (endDate - startDate) / (24 * 60 * 60 * 1000)
            if (middle > 7) {
              this.$notify.warning({
                title: this.$t('tishi'),
                message: this.$t('riqifanweizhinengxianzhi7tian')
              })
              delete this.conditions["startTime"]
              delete this.conditions["endTime"]
              this.conditions = {}
                ++this.key
            }
          }
        },
        immediate: false,
        deep: true
      },
      equipmentId: {
        handler(n, o) {
          if (n !== '') {
            this.getParamDict()
            this.$refs['shortcut'].selectTag = []
          }
        },
        immediate: false
      },
      app(newValue, oldValue) {
        this.resize()
      }
    },
    mounted() {
      this.resize()
      this.utils.event_hub.$on('RESIZE', () => {
        this.resize();
      });
      this.$nextTick(function () {
        this.closeFilter();
      });
    },
    methods: {
      /**
       * 页码
       * @param val
       */
      handleSizeChange(val) {
        // console.log('dddd',val)
        this.pagination.pageSize = val
        this.pagination.currentPage = 1
      },
      /**
       * 分页
       * @param val
       */
      handleCurrentChange(val) {
        this.pagination.currentPage = val
      },
      resize() {
        //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
        setTimeout(() => {
          // this.screenWidth = document.body.clientWidth
          if (this.chartList.length > 0) {
            for (let i = 0; i < this.chartList.length; i++) {
              if (this.chartList[i]['barChart'] != null) {
                this.chartList[i]['barChart'].resize()
              }
            }
          }
        }, 500)
      },
      // 重置参数
      reset() {
        this.chartList = []
        this.equipmentId = ''
        this.sn = ''
        this.pointCodes = []
        this.paramDict = []
        this.conditions = {}
        this.$refs['shortcut'].selectTag = []
        this.$refs['shortcut'].selectIndex = -1
        this.tableColumn = []
        this.tableData = []
        this.list = []
        this.multiChart= true
          ++this.key
        this.cancelRequest(); // 在重置时取消请求
      },
      cancelRequest() {
        if (this.axiosCancelSource) {
          this.axiosCancelSource.cancel('Request canceled by user.');
        }
      },

      // 工艺参数中文映射
      getCNNameByCode(code) {
        let res = this.paramDict.filter(item => {
          return item.code == code
        })
        if (res.length > 0) {
          const unit = res[0]['unit'];
          return unit ? res[0]['i18n'] + '(' + unit + ')' : res[0]['i18n'];
        } else {
          return code
        }
      },

      // 获取工艺参数映射字典
      getParamDict() {
        return this.http.get('/web/config/craft/template/getCreaftTemplateByEquipmentId', {
            params: {
              equipmentId: this.equipmentId
            }
          })
          .then(response => {
            if (response.data.length > 0) {
              let arr = response.data.map(item => {
                if (item.data.length > 0) {
                  return item.data
                }
              })
              for (let i = 0; i < arr.length; i++) {
                for (let j = 0; j < arr[i].length; j++) {
                  this.paramDict.push(arr[i][j])
                }
              }
              this.$emit('changeParamDict', this.paramDict)
            }
          })
          .catch((error) => {
            this.utils.errorMessage(error);
          });
      },
      // 时间转换
      timestampToTime(time) {
        const t = new Date(time)
        // 日期格式
        const format = 'Y-m-d h:i:s'
        let year = t.getFullYear()
        // 由于 getMonth 返回值会比正常月份小 1
        let month = t.getMonth() + 1
        let day = t.getDate() + '\n'
        let hours = t.getHours()
        let minutes = t.getMinutes()
        let seconds = t.getSeconds()
        month = month > 9 ? month : `0${month}`
        day = day > 9 ? day : `0${day}`
        hours = hours > 9 ? hours : `0${hours}`
        minutes = minutes > 9 ? minutes : `0${minutes}`
        seconds = seconds > 9 ? seconds : `0${seconds}`
        const hash = {
          'Y': year,
          'm': month,
          'd': day,
          'h': hours,
          'i': minutes,
          's': seconds
        }
        return format.replace(/\w/g, o => {
          return hash[o]
        })
      },
      // 已选工艺参数
      selectTag(value) {
        this.pointCodes = value
      },
      // 工艺分析图标
      getCraftAnalyze() {
        this.tableData = [];
        // 在发起新请求前取消之前的请求
        this.cancelRequest();

        // 创建一个新的cancelToken
        this.axiosCancelSource = axios.CancelToken.source();
		    ++this.reKey
        // 判断
        if (!this.conditions.startTime || !this.conditions.endTime) {
          this.$message.error(this.$t('caijishijianbitian'))
          return
        }
        if (!this.conditions.equipmentIds) {
          this.$message.error(this.$t('shebeimingchengbitian'))
          return
        }
        if (this.pointCodes.length === 0) {
          this.$message.error(this.$t('qingxuanzegongyicanshu'))
          return
        }
		    this.loading = true
        let requestParam = {
          ...this.conditions
        }
        if (requestParam['equipmentIds']) {
          requestParam['equipmentIds'] = requestParam['equipmentIds']
        } else {
          requestParam['equipmentIds'] = ''
        }
        requestParam['pointCodes'] = this.pointCodes.join(',') // 开启
        return this.http.get('/web/data/template/craft/analyze/list?' + this.qs.stringify(requestParam), {
          cancelToken: this.axiosCancelSource.token
        }).then(response => {
          const arr = response.data || []
          this.list = arr
          if (arr.length > 0) {
            this.tableColumn = [{
              label: 'caijishijian',
              prop: 'time'
            }]
            let pointCodes = requestParam['pointCodes'].split(',')
            if (pointCodes.length === 0) {
              return
            }
            for (let i = 0; i < pointCodes.length; i++) {
              this.tableColumn.push({
                label: this.getCNNameByCode(pointCodes[i]),
                prop: pointCodes[i]
              })
            }
            for (let i = 0; i < arr.length; i++) {
              const item = {
                time: arr[i]['time']
              }
              for (let j = 0; j < arr[i]['points'].length; j++) {
                item[arr[i]['points'][j]['code']] = arr[i]['points'][j]['value']
              }
              this.tableData.push(item)

              // 判断首个数据的时间是否大于筛选时间，防止与折线图起始位置不一致
              if (i === 0 && arr[i]['time'] > this.conditions['startTime']){
                this.conditions['startTime'] = arr[i]['time']
              }
            }
          }
        }).catch(error => {
          if (axios.isCancel(error)) {
            // 请求被取消
            console.log("Request canceled", error.message);
          } else {
            this.$message.error(this.$t(error));
          }
        }).finally(() => {
          this.loading = false;
        })
      },

      closeFilter() {
        this.showAll = !this.showAll;
        var searchBoxHeght = document.getElementById("searchBox");
        if (this.showAll == false) {
          searchBoxHeght.style.height = 60 + "px";
        } else {
          searchBoxHeght.style.height = "auto";
        }
      },

      getShiftType() {
        return this.http.get('/web/setting/shiftType/page').then(response => {
          this.shiftTypeList = response.data.rows
        }).catch(error => {

        })
      }

    }

  }
</script>
